import { useMemo } from 'react';
import { useCategoryProperties } from './useCategoryProperties';
import { useParseQuery } from './useParseQuery/useParseQuery';
import { mapCollectionPropertyOptionsToCollection } from './useParseQuery/useParseQuery.helpers';
import { PropertyOptions } from './useParseQuery/useParseQuery.types';
import {
  getHiddenPropertyIds,
  pruneHiddenPropertyOptions,
} from '@/utils/propertyVisibility';

export function usePrunedPropertyOptions(): PropertyOptions {
  const { categoryProperties, isCategoriesLoading } = useCategoryProperties();
  const { propertyOptions } = useParseQuery();

  return useMemo(() => {
    if (isCategoriesLoading) return propertyOptions;
    const hiddenIds = getHiddenPropertyIds(
      categoryProperties ?? [],
      mapCollectionPropertyOptionsToCollection(propertyOptions.collection)
    );
    if (!hiddenIds.length) return propertyOptions;
    return {
      collection: pruneHiddenPropertyOptions(
        propertyOptions.collection,
        hiddenIds
      ),
      boolean: pruneHiddenPropertyOptions(propertyOptions.boolean, hiddenIds),
      range: pruneHiddenPropertyOptions(propertyOptions.range, hiddenIds),
      string: pruneHiddenPropertyOptions(propertyOptions.string, hiddenIds),
    };
  }, [categoryProperties, isCategoriesLoading, propertyOptions]);
}
